import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MyPayHistoryState {
  period: '1month' | '1year' | '3year';
  page: number;
}

const initialState: MyPayHistoryState = {
  period: '1month',
  page: 1,
};

const myPayHistorySlice = createSlice({
  name: 'myPayHistory',
  initialState: initialState,
  reducers: {
    setMyPayHistoryPeriod: (
      state,
      action: PayloadAction<MyPayHistoryState['period']>,
    ) => {
      state.period = action.payload;
    },
    setMyPayHistoryPage: (
      state,
      action: PayloadAction<MyPayHistoryState['page']>,
    ) => {
      state.page = action.payload;
    },
  },
});

export const { setMyPayHistoryPeriod, setMyPayHistoryPage } =
  myPayHistorySlice.actions;

export default myPayHistorySlice.reducer;
